import Roles from "@src/constants/Roles";
import { User } from "@src/state/currentUserState";
import get from "lodash/get";

const PermissionLevelRanks = {
  view: 1,
  edit: 2,
} as const;

export const isSiteAdminRole = (roleSlug: string): boolean =>
  roleSlug === Roles.SiteAdmin;

export const getHasRole = (user: User, requiredRoleSlug: string): boolean => {
  if (
    user.role &&
    (user.role == requiredRoleSlug || isSiteAdminRole(user.role))
  ) {
    return true;
  }
  return false;
};

export const getHasPermission = (
  user: User,
  requiredPermissionSlug: string,
  requiredLevel: string,
): boolean => {
  if (isSiteAdminRole(user.role)) {
    // Site admins get everything
    return true;
  }

  const requiredRank = get(PermissionLevelRanks, requiredLevel);

  return user.permissions.some(
    (p) =>
      p.permission === requiredPermissionSlug &&
      get(PermissionLevelRanks, p.level) >= requiredRank,
  );
};
